<script setup>
import GbButton from '@/components/GbButton.vue'
import DropdownButton from '@/components/DropdownButton.vue'
import { ref } from 'vue'
import SaveToLibrary from '@/library/SaveToLibrary.vue'

const downloadDropdownItems = ref([
  {
    label: 'Download Assessment Collection (PDF)',
    command: () => {}
  }
])
</script>
<template>
  <div class="card">
    <h3 class="header-md pb-1">Colors</h3>
    <GbButton gbTheme="bluePrimary" label="Primary" class="m-2" />
    <GbButton
      gbTheme="bluePrimary"
      label="Disabled Blue Primary"
      class="m-2"
      aria-label="Disabled button - this should tell you why the button is disabled"
      aria-disabled="true"
    />
    <GbButton gbTheme="purplePrimary" label="Purple Primary" class="m-2" />
    <GbButton gbTheme="greenPrimary" label="Green Primary" class="m-2" />
    <GbButton
      gbTheme="greenPrimary"
      label="Disabled Green Primary"
      class="m-2"
      aria-label="Disabled button - this should tell you why the button is disabled"
      aria-disabled="true"
    />
    <GbButton gbTheme="redPrimary" label="Red Primary" class="m-2" /><br />
    <GbButton gbTheme="grayOutlineSecondary" label="Gray Outline Secondary" class="m-2" />
    <GbButton gbTheme="blueOutlineSecondary" label="Blue Outline Secondary" class="m-2" />
    <GbButton gbTheme="purpleOutlineSecondary" label="Purple Outline Secondary" class="m-2" />
    <GbButton gbTheme="greenOutlineSecondary" label="Green Outline Secondary" class="m-2" />
    <GbButton gbTheme="redOutlineSecondary" label="Red Outline Secondary" class="m-2" /><br />
    <GbButton gbTheme="grayFillSecondary" label="Gray Fill Secondary" class="m-2" />
    <GbButton gbTheme="blueFillSecondary" label="Blue Fill Secondary" class="m-2" />
    <GbButton gbTheme="purpleFillSecondary" label="Purple Fill Secondary" class="m-2" /><br />
    <GbButton gbTheme="grayTertiary" label="Gray Tertiary" class="m-2" />
    <GbButton gbTheme="blueTertiary" label="Blue Tertiary" class="m-2" />
    <GbButton gbTheme="purpleTertiary" label="Purple Tertiary" class="m-2" />
    <GbButton gbTheme="greenTertiary" label="Green Tertiary" class="m-2" />
    <GbButton gbTheme="redTertiary" label="Red Tertiary" class="m-2" />
    <h3 class="header-md pb-1 pt-2">Sizes</h3>
    <GbButton gbTheme="bluePrimary" label="XL" size="xl" class="m-2" />
    <GbButton gbTheme="bluePrimary" label="Large" size="large" class="m-2" />
    <GbButton gbTheme="bluePrimary" label="Medium/Default" class="m-2" />
    <GbButton gbTheme="bluePrimary" label="Small" size="small" class="m-2" />
    <GbButton gbTheme="bluePrimary" label="XS" size="xs" class="m-2" />
    <h3 class="header-md pb-1 pt-2">Icons</h3>
    <GbButton gbTheme="bluePrimary" aria-label="medium Globe button" :iconOnly="true" class="m-2">
      <span class="material-icons-outlined text-2xl">public</span>
    </GbButton>
    <GbButton
      gbTheme="bluePrimary"
      aria-label="small Globe button"
      size="small"
      :iconOnly="true"
      class="m-2"
    >
      <span class="material-icons-outlined text-display-sm">public</span>
    </GbButton>
    <GbButton
      gbTheme="bluePrimary"
      aria-label="xs Globe button"
      size="xs"
      :iconOnly="true"
      class="m-2"
    >
      <span class="material-icons-outlined text-lg">public</span>
    </GbButton>
    <GbButton
      gbTheme="grayTertiary"
      aria-label="gray tertiary round icon button"
      :iconOnly="true"
      class="m-2"
      rounded
    >
      <span class="material-icons-outlined text-2xl">public</span>
    </GbButton>
    <h3 class="header-md pb-1 pt-2">Button with Dropdown</h3>
    <DropdownButton
      buttonAriaLabel="Download options"
      :items="downloadDropdownItems"
      buttonTheme="bluePrimary"
      buttonSize="small"
      dropdownId="bluePrimaryDropdown"
    >
      <template #buttonContents>
        <span class="material-icons-outlined text-display-xs">file_download</span>
        Download
        <span class="material-icons-round text-display-xs">arrow_drop_down</span>
      </template>
    </DropdownButton>

    <section class="mb-12">
      <h2 class="text-2xl font-semibold mb-4">Save To Library</h2>
      <div class="flex flex-wrap gap-4">
        <SaveToLibrary content-type="resource" content-type-label="Resource" content-uuid="e9a5bd7e-6cbe-4c1b-6ae8-084d6407d279"/>
      </div>
    </section>
  </div>
</template>
